var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95066 7.29289L16.1806 2.14645C16.4169 1.95118 16.8002 1.95118 17.0365 2.14645C17.2729 2.34171 17.2729 2.65829 17.0365 2.85355L10.8066 8L17.0365 13.1464C17.2729 13.3417 17.2729 13.6583 17.0365 13.8536C16.8002 14.0488 16.4169 14.0488 16.1806 13.8536L9.95066 8.70711L3.72075 13.8536C3.48438 14.0488 3.10115 14.0488 2.86478 13.8536C2.62841 13.6583 2.62841 13.3417 2.86478 13.1464L9.09469 8L2.86478 2.85355C2.62841 2.65829 2.62841 2.34171 2.86478 2.14645C3.10115 1.95118 3.48438 1.95118 3.72075 2.14645L9.95066 7.29289Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.6aceb6d9910bc62a7beb7b8977199cdd.svg";
export { ForwardRef as ReactComponent };